import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { id: "map-tool" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Search", -1)
const _hoisted_4 = {
  key: 0,
  class: "suggestions"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Filters:", -1)
const _hoisted_7 = { class: "sidebar-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "map-container" }
const _hoisted_10 = { ref: "mapContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        class: "search-bar",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
        placeholder: "Search organizations...",
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchSuggestions && _ctx.fetchSuggestions(...args))),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => ($setup.showSuggestions = true)),
        onBlur: $setup.hideSuggestions
      }, null, 544), [
        [_vModelText, $setup.searchQuery]
      ]),
      ($setup.showSuggestions && $setup.searchResults.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchResults, (org) => {
              return (_openBlock(), _createElementBlock("li", {
                key: org.id,
                onClick: ($event: any) => ($setup.selectSuggestion(org))
              }, _toDisplayString(org.name), 9, _hoisted_5))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _hoisted_6,
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.filters, (filter) => {
          return _createElementVNode("li", {
            key: filter,
            onClick: ($event: any) => ($setup.applyFilter(filter)),
            class: _normalizeClass({ 'active-filter': $setup.selectedFilter === filter })
          }, _toDisplayString(filter), 11, _hoisted_8)
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("article", _hoisted_10, null, 512),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}